import cx from 'classnames';
import styles from '../components/Icons/Icons.module.scss';
import ProcessorIcon from './raw/processor.svg?react';
import type { IconProps } from './types';

const Processor = ({
  className,
  iconClass = true,
  label,
  style,
  viewBox,
}: IconProps) => (
  <ProcessorIcon
    aria-labelledby={label}
    xmlns="http://www.w3.org/2000/svg"
    title={label}
    shapeRendering="geometricPrecision"
    viewBox={viewBox || '0 0 24 24'}
    className={cx({
      [styles.svgIcon]: iconClass,
      ...(className
        ? {
            [styles[className]]: className && styles[className],
            [className]: className && !styles[className],
          }
        : {}),
    })}
    style={style}
  />
);

export default Processor;
